<mat-icon *ngIf="!isLoggedIn" type="button" (click)="authService.GoogleAuth()">
  login
</mat-icon>
<mat-icon *ngIf="isLoggedIn" type="button" (click)="authService.logOut()">
  logout
</mat-icon>
